import FilterControl from '../../components/modules/table/FilterControl'
import { duePeriodOptions, duePeriodRange } from './obligationDueFilters'

export default function ObligationDueControls({ value, onChange }) {
  const setDate = (key, date) =>
    onChange({ ...value, [key]: date, period: '' })

  return (
    <>
      <div className="flex flex-col min-w-0 w-full pt-1">
        <label
          htmlFor="due-from"
          className="text-xs font-sans font-medium text-gray-500 leading-none mb-0"
        >
          Vencimiento desde
        </label>

        <input
          id="due-from"
          type="date"
          value={value.from}
          max={value.to || undefined}
          onChange={event => setDate('from', event.target.value)}
          className="w-full min-w-0 h-8 border border-border rounded-full px-2 py-1 text-sm font-sans font-normal focus:outline-none focus:ring-2 focus:ring-primary/30"
        />
      </div>

      <div className="flex flex-col min-w-0 w-full pt-1">
        <label
          htmlFor="due-to"
          className="text-xs font-sans font-medium text-gray-500 leading-none mb-0"
        >
          Vencimiento hasta
        </label>

        <input
          id="due-to"
          type="date"
          value={value.to}
          min={value.from || undefined}
          onChange={event => setDate('to', event.target.value)}
          className="w-full min-w-0 h-8 border border-border rounded-full px-2 py-1 text-sm font-sans font-normal focus:outline-none focus:ring-2 focus:ring-primary/30"
        />
      </div>

      <div className="min-w-0 pt-5">
        <FilterControl
          label="Período de vencimiento"
          value={value.period}
          fullWidth
          options={duePeriodOptions()}
          onChange={period =>
            onChange({ period, ...duePeriodRange(period) })
          }
        />
      </div>
    </>
  )
}